import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs.tsx';
import UserGuidePage from './UserGuidePage.tsx';
import MyCompositesTab from './MyCompositesTab.tsx';

const AppHomePage: React.FC = () => {
  return (
    <div className="p-4">
      <Tabs defaultValue="my-composites" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="user-guide">User Guide</TabsTrigger>
          <TabsTrigger value="my-composites">My Composites</TabsTrigger>
        </TabsList>
        <TabsContent value="user-guide">
          <UserGuidePage />
        </TabsContent>
        <TabsContent value="my-composites">
          <MyCompositesTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AppHomePage;
